import { Route, Routes } from "react-router-dom";

import AllLeads from "./AllLeads/AllLeads";
import LeadDetails from "./LeadDetails";

export default function Leads() {
  return (
    <Routes>
      <Route path="/" element={<AllLeads />} />
      <Route path=":profileId" element={<LeadDetails />} />
    </Routes>
  );
}
